/** Opaque blank width when formatConfig layoutCh is missing (never answer-derived). */
export const DEFAULT_BLANK_LAYOUT_CH = 12;

const LAYOUT_CH_MIN = 4;
const LAYOUT_CH_MAX = 64;
const LAYOUT_CH_BUCKET = 4;

/**
 * Bucket character width for FIB blanks: `ceil(len/4)*4`, clamped to [4, 64].
 * Used at normalize time from answer lengths — never in the player from live answer text.
 */
export function bucketLayoutCh(len: number): number {
	const safe = Number.isFinite(len) ? Math.max(0, Math.floor(len)) : 0;
	const bucketed =
		Math.ceil(Math.max(safe, 1) / LAYOUT_CH_BUCKET) * LAYOUT_CH_BUCKET;
	return Math.min(LAYOUT_CH_MAX, Math.max(LAYOUT_CH_MIN, bucketed));
}
